import React, { useState, useEffect } from "react";
import Image from "next/legacy/image";

import HomeHeader from "./HomeHeader";
import SeoLinks from "./SeoLinks";
import HomeFooter from "./HomeFooter";

import Button from "@/ui/Button";

import GetStartedOptions from "../Logo/GetStartedOptions";
import GetStartedCustomized from "../Logo/GetStartedCustomized";
import GetStartedSupport from "../Logo/GetStartedSupport";
import GetStartedEmpowering from "../Logo/GetStartedEmpowering";
import GetStartedAccessible from "../Logo/GetStartedAccessible";

import { useAuth } from "@/lib/auth";
import { readDocument } from "@/lib/db";
import { imageLoader } from "@/utils/image";

import {
    MenuIcon,
    LoginIcon,
    LogoutIcon,
    MailIcon,
    HeartIcon,
    BookOpenIcon,
    CalculatorIcon,
} from "@heroicons/react/outline";
import { UserIcon, UserCircleIcon } from "@heroicons/react/solid";

import SignUpSignIn from "../user/SignUpSignIn";
import { isSignedIn } from "@/components/user/UserUtils";

import PurpleDoorLogoRect from "../Logo/PurpleDoorLogoRect";

const HomeRegister = () => {
    const auth = useAuth();
    const [user, setUser] = useState({});
    const [openSignUp, setOpenSignUp] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);

    const userId = auth.user ? auth.user.uid : "";

    useEffect(() => {
        const getUser = async (uid) => {
            const user = await readDocument("users", uid);
            setUser(user);
        };

        if (userId) {
            getUser(userId);
        }
    }, [userId]);

    const handleSignOut = () => {
        auth.signOut();
        setOpenSignUp(false);
        setOpenSignIn(false);
    };

    console.log("user", user);

    return (
        <div>
            <HomeHeader fixed />

            <div className="relative">
                <div className="container mx-auto px-8 sm:px-16">
                    <div className="w-1/2 pt-40 pr-8 ">
                        <h2 className="text-gray-sec text-2xl font-bold tracking-normal font-headline uppercase">
                            For Seniors + Their Families
                        </h2>
                        <h1 className="mt-2 text-primary-500 text-4xl font-bold tracking-normal font-headline">
                            Start your search for living options based on your individual
                            needs
                        </h1>

                        <p className="mt-12">
                            Navigating the process of finding the best senior living option
                            can be difficult. You probably are new to this. You are probably
                            trying to figure out all of the details. And your primary
                            concern is the quality of life that the transition to senior
                            living, assisted living or other living and care choices will
                            have on you and your family.
                        </p>

                        <br />

                        <p>
                            Purple Door believes that people come first, and that people
                            want to make informed confident decisions about senior living.
                            That’s why we do things differently.
                        </p>

                        <br />

                        <p>
                            Start your FREE account to start using the tools to help you
                            find senior living and care options that meet your needs.
                        </p>

                        {isSignedIn(auth, true) ? (
                            <div className="mt-8 pb-8">
                                <span className="font-bold">
                                    You are currently signed in ({user.email})
                                </span>

                                <buton
                                    className="ml-4 text-purple-500 hover:underline"
                                    onClick={handleSignOut}
                                >
                                    Sign Out
                                </buton>
                            </div>
                        ) : (
                            <div className="mt-8 pb-8">
                                <div className="flex items-center">
                                    <Button
                                        className=""
                                        onClick={() => {
                                            setOpenSignUp(true);

                                            gtag("event", "conversion", {
                                                send_to:
                                                    "AW-10778046073/z0kvCMDQspMaEPncr5Mo",
                                            });

                                            oaiq(
                                                "measure",
                                                "registration_completed",
                                                { type: "customer_action" }
                                            );
                                        }}
                                    >
                                        Create Account
                                    </Button>
                                </div>

                                <div className="mt-4 flex items-center">
                                    Already have an account?
                                    <buton
                                        className="ml-4 text-purple-500 hover:underline"
                                        onClick={() => setOpenSignIn(true)}
                                    >
                                        Sign In
                                    </buton>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="absolute top-0 left-1/2 right-0 bottom-0">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/register-account"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>
            </div>

            <PurpleDoorBelieves />

            <div className="container mx-auto px-8 sm:px-16 flex justify-center">
                <div className="py-16 max-w-3xl">
                    <h2 className="text-center text-gray-sec text-2xl font-bold tracking-normal font-headline uppercase">
                        For Seniors + Their Families
                    </h2>

                    <h1 className="mt-4 text-center text-primary-500 text-4xl font-bold tracking-normal font-headline uppercase">
                        Get Started Now
                    </h1>

                    <p className="mt-8 text-lg text-center">
                        Start your FREE account to start using the tools to help you find
                        senior living and care options that meet your needs.
                    </p>

                    <div className="flex justify-center">
                        {isSignedIn(auth, true) ? (
                            <div className="mt-8">
                                <span className="font-bold">
                                    You are currently signed in ({user.email})
                                </span>

                                <buton
                                    className="ml-4 text-purple-500 hover:underline"
                                    onClick={handleSignOut}
                                >
                                    Sign Out
                                </buton>
                            </div>
                        ) : (
                            <div className="mt-8">
                                <div className="flex justify-center items-center">
                                    <Button
                                        className=""
                                        onClick={() => {
                                            setOpenSignUp(true);

                                            gtag("event", "conversion", {
                                                send_to:
                                                    "AW-10778046073/z0kvCMDQspMaEPncr5Mo",
                                            });

                                            oaiq(
                                                "measure",
                                                "registration_completed",
                                                { type: "customer_action" }
                                            );
                                        }}
                                    >
                                        Create Account
                                    </Button>
                                </div>

                                <div className="mt-4 flex justify-center items-center">
                                    Already have an account?
                                    <buton
                                        className="ml-4 text-purple-500 hover:underline"
                                        onClick={() => setOpenSignIn(true)}
                                    >
                                        Sign In
                                    </buton>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <SignUpSignIn
                openSignUp={openSignUp}
                openSignIn={openSignIn}
                setOpenSignUp={setOpenSignUp}
                setOpenSignIn={setOpenSignIn}
            />

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

const Promise = ({ title, children, Icon }) => {
    return (
        <div className="flex flex-col items-center">
            <Icon width={96} height={96} />
            <h3 className="mt-6 text-center text-primary-500 text-2xl font-headline font-bold uppercase">
                {title}
            </h3>
            <p className="mt-8 text-center text-lg">{children}</p>
        </div>
    );
};

export const PurpleDoorBelieves = () => {
    return (
        <div className="w-full bg-gray-sec/50">
            <div className="container mx-auto px-8 sm:px-16">
                <div className="py-16">
                    <div className="flex justify-center">
                        <h2 className="max-w-5xl text-center text-primary-500 text-3xl font-headline font-bold">
                            Purple Door believes that people come first, and that people
                            want to make informed, confident decisions about senior living.
                            That’s why we do things differently.
                        </h2>
                    </div>

                    <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-x-12 gap-y-8">
                        <Promise title="Options" Icon={GetStartedOptions}>
                            PurpleDoorFinders.com offers access to one of the most extensive
                            senior living and care options databases. From independently
                            operated board and care homes to large, full-amenity
                            communities, our platform includes a wide range of choices,
                            including senior apartments, independent living, assisted
                            living, memory care, hospice, in-home care agencies, nursing
                            homes, skilled nursing facilities, and respite care services.
                        </Promise>

                        <Promise title="Customized" Icon={GetStartedCustomized}>
                            Each senior, their family, or their advocates have unique needs
                            and preferences. PurpleDoorFinders.com helps you search based on
                            those specific criteria, and you are presented with options
                            before taking tours and meeting with communities, facilities,
                            and agencies.
                        </Promise>

                        <Promise title="Support" Icon={GetStartedSupport}>
                            PurpleDoorFinders.com offers a comprehensive suite of tools and
                            resources designed to streamline the process of finding
                            communities, agencies, and facilities. Our platform allows you
                            to efficiently manage search preferences, track interest,
                            compare options, coordinate tours, and communicate directly— all
                            through your personalized sign-in profile portal.
                        </Promise>

                        <Promise title="Empowering" Icon={GetStartedEmpowering}>
                            At PurpleDoorFinders.com, we do not employ agents, specialists,
                            or advisors who promote specific communities, facilities, or
                            companies within our platform. Instead, we offer a
                            comprehensive, unbiased selection of all available options that
                            we are aware of. Our database highlights available vacancies and
                            other real-time information. We also provide valuable links for
                            accessing report cards for assisted living communities through
                            their respective state licensing agencies.
                        </Promise>

                        <Promise title="Accessible" Icon={GetStartedAccessible}>
                            Our website is a free resource for seniors, families, and
                            advocates to search for senior living and care options.
                            Communities pay a low monthly subscription to list vacancies,
                            incentives, caregiver availability, and event invitations.
                            Unlike competitors that use commission-based salespeople and
                            gate access, our platform allows direct communication with
                            communities. We invite all communities, facilities, and agencies
                            to join at no cost, ensuring a comprehensive view of all
                            available options.
                        </Promise>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeRegister;
